import BankLogo from 'components/BankLogo'
import AddCircle from 'components/Icons/AddCircle'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import palette from 'components/palette'
import { Bank } from 'data/Payments/BankTransfer/types'
import { BeneficiaryType } from 'data/types'
import React from 'react'
import BankOption from 'scenes/Cashflow/BankOption'
import styled from 'styled-components'

import { BigOptionBody, OptionContent, OptionTitle, SelectMethodButton } from './styles'

const FiatSelectMethodButton = styled(SelectMethodButton)<{ empty?: boolean }>`
  padding: ${(p) => (p.empty ? '1.5rem' : '0.75rem')} 1rem;
  margin: 1rem 0 0 0;
`

type Props = {
  bank?: Bank
  beneficiary?: BeneficiaryType
  e2e: string
  hasError?: boolean
  onClick: () => void
  title: React.ReactNode
}

const BeneficiaryButton = ({ bank, beneficiary, e2e, hasError, onClick, title }: Props) => {
  if (bank) {
    return (
      <FiatSelectMethodButton data-e2e={e2e} onClick={onClick}>
        <BankOption bank={bank} />
      </FiatSelectMethodButton>
    )
  }

  if (beneficiary) {
    return (
      <FiatSelectMethodButton data-e2e={e2e} onClick={onClick}>
        <BankLogo />
        <OptionContent>
          <OptionTitle>{beneficiary.name}</OptionTitle>
          <BigOptionBody>{beneficiary.address}</BigOptionBody>
        </OptionContent>
      </FiatSelectMethodButton>
    )
  }

  return (
    <FiatSelectMethodButton data-e2e={e2e} empty hasError={hasError} onClick={onClick}>
      <AddCircle fill={palette.blue600} />
      <span>{title}</span>
      <Arrow side={ArrowSide.RIGHT} />
    </FiatSelectMethodButton>
  )
}

export default BeneficiaryButton
